import { FieldError, Merge } from 'react-hook-form'

export const getMultiSelectErrorMessage = (
  errors?: Merge<FieldError, (FieldError | undefined)[]>,
) => {
  if (errors?.length) {
    const message = (errors as FieldError[]).find(
      (error) => error?.message,
    )?.message

    return message
  }

  return errors?.message
}
